import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-branch-complaints-detail',
  templateUrl: './branch-complaints-detail.component.html'
})
export class BranchComplaintsDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
